import { Type } from "@scalar/typebox";
const RoutingSchema = Type.Partial(
  Type.Object({
    basePath: Type.String(),
    pathNotFound: Type.String()
  })
);
const defaultRouting = {
  basePath: "/",
  pathNotFound: "/"
};
export {
  RoutingSchema,
  defaultRouting
};
//# sourceMappingURL=routing.js.map
